const groupVpsHostingFaqFields = (fields) => {
  const introFields = fields
    .filter((field) => field.key === 'title' || field.key === 'subtitle')
    .sort((a, b) => a.sortOrder - b.sortOrder);

  const faqGroups = [];

  const indexes = new Set();
  fields.forEach((field) => {
    const match = field.key.match(/^faq-(\d+)-question$/);
    if (match) {
      indexes.add(Number(match[1]));
    }
  });

  [...indexes].sort((a, b) => a - b).forEach((index) => {
    const groupFields = fields
      .filter((field) => field.key === `faq-${index}-question` || field.key === `faq-${index}-answer`)
      .sort((a, b) => a.sortOrder - b.sortOrder);

    if (groupFields.length > 0) {
      faqGroups.push({ index, fields: groupFields });
    }
  });

  return { introFields, faqGroups };
};

export const getNextVpsHostingFaqIndex = (fields) => {
  const indexes = fields
    .map((field) => {
      const match = field.key.match(/^faq-(\d+)-question$/);
      return match ? Number(match[1]) : 0;
    })
    .filter(Boolean);

  return indexes.length === 0 ? 1 : Math.max(...indexes) + 1;
};

export default groupVpsHostingFaqFields;
